import Backbone from "backbone";
import $ from "jquery";
import SharedDispatcher from "../../../common/others/SharedDispatcher";

export default Backbone.View.extend({

  events: {
    'change .js-MailAlerting-interestListItem--selector': 'changeInterest',
    'click .js-closePopin': 'closePopin',
  },

  initialize: function(options) {
    this.interest = options.interest;
  },

  closePopin: function(e) {
    e.preventDefault();
    $.magnificPopup.close();
  },

  changeInterest: function(e) {
    e.preventDefault();
    var interestId = $(e.currentTarget).data('id');
    SharedDispatcher.trigger(e.currentTarget.checked ? 'MailAlert:add' : 'MailAlert:remove',
      { parentId: this.interest.Id || 0, id: interestId });
  }
});
